module.exports = __webpack_public_path__ + "792dcd18baf5f544aabcad1883d673c2.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-widgets/lib/fonts/rw-widgets.svg?v=4.1.0
// module id = 1760
// module chunks = 0